export default {
  getterCategories          : state => state.categories,
  getterVisibleCategories   : state => state.visibleCategories,
  getterCreatableCategories : state => state.creatableCategories
};
